module.exports = __webpack_public_path__ + "static/media/Cross-black.1d267a78.svg";